import {convertToISOString} from './convertToISOString';

export const getDateFromISOString = (date: Date) => {
  const dateString = convertToISOString(date);
  return dateString.split('T')[0];
};
